import React from 'react';
import './scss/orderpopup.scss';
export default class orderPopup extends React.Component{
    constructor(props){
        super(props);
        this.state={
            
        }
    }
    getCancel(e){
        this.props.getCancel(false)
    }
    getConfirm(e){
        this.props.getConfirm(false)
    }
    render(){
        return (
            <div className="wrapout">
                <div className="weinner">
                    <div className="whead_top">
                        <i className="icon_hg ico-type1"></i>取消订单
                    </div>
                    <div className="wTcontent">您确定要取消订单吗？</div>
                    <div className="wbtn">
                        <span className="webtn cacel" onClick={(e)=>this.getCancel(e)}>取消</span>
                        <span className="webtn comfir" onClick={(e)=>this.getConfirm(e)}>确定</span>
                    </div>
                </div>
            </div>
        )
    }
}